import { MutableValue } from "../api/mutable-value.interface";

export default class EmailLayout implements MutableValue {
  public isNew = true;

  constructor(
    private fId: string,
    private fContent: string,
    private fStore: number
  ) {
    [fId, fContent, fStore].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get content(): string {
    return this.fContent;
  }

  get store(): number | undefined {
    return this.fStore;
  }
}
